import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorHandlerService } from '../services/error-handler.service';
import { CommonFunctions } from '../static/common-functions';

@Component({
  selector: 'cp-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  ngClasses: { [key: string]: boolean; } = {};

  @Input() type: string;
  @Input() modal: boolean;
  @Input() fullScreen: boolean;
  @Input() state: boolean;
  @Input() customCss: string;
  @Input() message: string;

  constructor(private errorHandlerService: ErrorHandlerService) { }

  private sub_error: Subscription;

  ngOnInit(): void {
    this.ngClasses = {
      'sm': this.type === 'sm',
      'md': this.type === 'md',
      'lg': this.type === 'lg',
      'blocked': this.modal === true,
    };

    if (this.customCss) {
      this.ngClasses[this.customCss] = true;
    }

    this.sub_error = this.errorHandlerService.apiError$.subscribe(err => {
      // If an error occurs and the loader ON and is in modal or full screen mode, turn off the loader
      if (err && this.state && (this.modal || this.fullScreen)) {
        this.state = false;
      }
    });
  }

  ngOnDestroy(): void {
    CommonFunctions.unsubscribe(this.sub_error);
  }
}